import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import useReload from "../../hooks/useReload";
import { FilterBar } from "../../widgets";
import moment from "moment";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import useApp from "../../hooks/useApp";

const ClientAccount = (props) => {
  const { reload } = useReload();
  const { id = "" } = useParams();
  const { scope = "" } = props;
  const { Paginate, searchParamString } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const navigate = useNavigate();
  const { showAlert } = useApp();

  const getAccount = async (searchString) => {
    try {
      const url = `/clients/${id}/account`;
      const { data } = await api.read(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: clientAccount, refetch } = useQuery(
    ["clientAccount", searchParamString, auth],
    ({ queryKey }) => getAccount(queryKey[1])
  );

  const createAccount = async () => {
    const { isConfirmed } = await Swal.fire({
      title: "Are you sure?",
      text: "You want to create account for client!\n An Email will be sent to client to complete process",
      icon: "warning",
      confirmButtonText: "Yes, Create",
      showCancelButton: true,
    });

    if (isConfirmed) {
      console.log("confirmed");
      try {
        const response = await api.addNew(`/clients/${id}/account`);
        console.log(response);
        if (response.ok) {
          showAlert(
            "Account Created. Email sent to client to complete process",
            "success"
          );
          refetch();
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log("not confirmed");
    }
  };

  return (
    <>
      {!props?.headless && (
        <>
          <h2 className="mb-0 mt-2">Client Account</h2>

          <div className="d-md-flex align-items-baseline mt-3">
            {!clientAccount && (
              <Button
                onClick={createAccount}
                variant="info"
                className="hstack gap-2 mb-3 me-2"
              >
                <i className="demo-psi-add fs-4"></i>
                <span className="vr"></span>
                Create Account
              </Button>
            )}
            <FilterBar />
          </div>
        </>
      )}
      <div className="table-responsive bg-white">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Username</th>
              <th>Date Created</th>
              <th>Status</th>
              <th>link</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {clientAccount && (
              <tr key={clientAccount.id}>
                <td>
                  {/* <Link to={`/policies/${policy.id}`} className="btn-link"> */}
                  {clientAccount?.Client?.name}
                  {/* </Link> */}
                </td>
                <td>
                  <span className="fw-bold">
                    {clientAccount?.Account?.username}
                  </span>
                </td>
                <td>
                  <>
                    <span>
                      {moment(clientAccount?.createdAt).format("DD/MM/YYYY") ||
                        ""}
                    </span>
                  </>
                </td>
                <td>
                  {clientAccount?.Account?.active ? (
                    <div className="badge bg-success">active</div>
                  ) : (
                    <div className="badge bg-danger">Inactive</div>
                  )}
                </td>
                <td>
                  {clientAccount?.Account?.active ? (
                    <div className="badge bg-success"></div>
                  ) : (
                    <div className="">{`https://surge.iuapps.net/client-account/${clientAccount.UserId}`}</div>
                  )}
                </td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
        <Paginate />
      </div>
    </>
  );
};

export default ClientAccount;
